import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-center space-x-3" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Save Changes", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mt-6 text-2xl font-medium text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Patient's Name: "),
  /*#__PURE__*/_createElementVNode("span", { class: "font-semibold text-neutral-900" }, "Sample Name")
], -1)
const _hoisted_4 = { class: "w-full px-6 py-6 mx-auto my-6 border border-gray-200 rounded-md" }
const _hoisted_5 = { class: "flex items-center justify-between" }
const _hoisted_6 = {
  key: 0,
  class: "grid grid-cols-6 gap-6 mt-6"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, null, -1)
const _hoisted_8 = { class: "col-span-2" }
const _hoisted_9 = { class: "col-span-2" }
const _hoisted_10 = { class: "col-span-2" }
const _hoisted_11 = { class: "col-span-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, [
  /*#__PURE__*/_createTextVNode("Gender "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-red-600" }, "*")
], -1)
const _hoisted_13 = { class: "flex items-center pt-5 space-x-6" }
const _hoisted_14 = { class: "col-span-2" }
const _hoisted_15 = { class: "col-span-2" }
const _hoisted_16 = { class: "col-span-2" }
const _hoisted_17 = { class: "col-span-2" }
const _hoisted_18 = { class: "col-span-2" }
const _hoisted_19 = { class: "col-span-2" }
const _hoisted_20 = { class: "col-span-2" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, "Lives with child", -1)
const _hoisted_22 = { class: "flex items-center pt-5 space-x-6" }
const _hoisted_23 = { class: "col-span-2" }
const _hoisted_24 = { class: "col-span-2" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, "Employed", -1)
const _hoisted_26 = { class: "flex items-center pt-5 space-x-6" }
const _hoisted_27 = { class: "col-span-2" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { class: "block text-xs font-semibold text-neutral-600" }, "OFW", -1)
const _hoisted_29 = { class: "flex items-center pt-5 space-x-6" }
const _hoisted_30 = { class: "col-span-2" }
const _hoisted_31 = { class: "col-span-2" }
const _hoisted_32 = { class: "col-span-2" }
const _hoisted_33 = { class: "col-span-2" }
const _hoisted_34 = { class: "col-span-2" }
const _hoisted_35 = { class: "col-span-2" }
const _hoisted_36 = { class: "col-span-2" }
const _hoisted_37 = { class: "col-span-6" }

import { onMounted, ref, computed } from "vue";
import UserLayout from "@/layouts/UserLayout.vue";
import ButtonComponent from "@/components/buttons/ButtonComponent.vue";
import SectionTitle from "@/components/partials/SectionTitle.vue";
import SuccessModal from "@/components/modals/SuccessModal.vue";
import TextInput from "@/components/inputs/TextInput.vue";
import MultiSelect from "@/components/inputs/MultiSelect.vue";
import RadioGroup from "@/components/inputs/RadioGroup.vue";
import DatePicker from "@/components/inputs/DatePicker.vue";
import { useRouter, useRoute } from "vue-router";
import IntakeService from "@/classes/Cases/IntakeService";
import { renderSelect, renderSelectV2 } from "@/interfaces/DropdownInterface";
import { IntakeCreate } from "@/interfaces/Cases/Intake";
import IntakeForm from "@/classes/Forms/Cases/IntakeForm";
import { errorResponse } from "@/helpers/errorMessage";
import { numberonly } from "@/components/composables/useNumberOnly"; 
import pickBy from "lodash/pickBy"; 


export default /*#__PURE__*/_defineComponent({
  __name: 'EditPage',
  setup(__props) {

const yesNoOption = [
	{ id: 1, label: "Yes", value: 1 },
	{ id: 0, label: "No", value: 0 },
];

const router = useRouter();
const route = useRoute();
const showSuccess = ref<boolean>(false);
const patientId = ref<number | null>(route.params.patient);
const caseId = ref<number | null>(route.params.case);
const intakeId = ref<number | null>(route.params.intake);
const genders = ref<renderSelectV2[]>([]);
const civilStatuses = ref<renderSelect[]>([]);
const housingClassifications = ref<renderSelect[]>([]);
const socioEconomics = ref<renderSelect[]>([]);
const legalStatuses = ref<renderSelect[]>([]);
const relationships = ref<renderSelect[]>([]);
const form = ref<IntakeCreate>(new IntakeForm());
const errors = ref<object>({});
const successMessage = ref<string>("Intake has been updated!");
const loaded = ref<boolean>(false);
const offlineParams = ref<string>(route.query.offline);

const disabledAge = computed(() => {
	if (form.value.birthdate) {
		return true;
	}

	if (form.value.birthdate?.length > 0) {
		return true;
	}

	return false;
});
const disabledBirthdate = computed(() => {
	if (disabledAge.value) {
		return false;
	}

	if (form.value.approximate_age == "0") {
		return false;
	}

	if (form.value.approximate_age) {
		return true;
	}

	if (form.value.approximate_age?.toString()?.length > 0) {
		return true;
	}

	return false;
});

const save = (): void => {
	errors.value = {};

	IntakeService.update(
		patientId.value,
		caseId.value,
		intakeId.value,
		{ ...form.value }
	)
		.then((response: object) => {
			showSuccess.value = true;
			successMessage.value = response.data.message;
		})
		.catch((error: object) => {
			errors.value = errorResponse(error.response?.data?.errors);
		});
};

const redirectSuccess = async (): void => {
	showSuccess.value = false; 
	router.replace(`/patient/${patientId.value}/cases/${caseId.value}/edit`);
};

const getData = (): void => {
	IntakeService.edit(
		patientId.value,
		caseId.value,
		intakeId.value,
		pickBy({ isOfflineData: offlineParams.value ? true : false })
	)
		.then((response: object) => {
			genders.value = response.data.genders;
			civilStatuses.value = response.data.civilStatuses;
			housingClassifications.value = response.data.housingClassifications;
			socioEconomics.value = response.data.socioEconomics;
			legalStatuses.value = response.data.legalStatuses;
			relationships.value = response.data.relationships;
			form.value.updateIntake(response.data.item);

			loaded.value = true;
		})
		.catch((error: object) => console.log(error));
};

onMounted(() => getData());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserLayout, {
    hasBack: "",
    backTitle: "Edit Intake",
    backLink: `/patient/${patientId.value}/cases/${caseId.value}/edit${offlineParams.value ? '?offline=true' : ''}`
  }, {
    lowerRight: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (
						_unref(router).replace(
							`/patient/${patientId.value}/cases/${caseId.value}/edit${offlineParams.value ? '?offline=true' : ''}`
						)
					))
        }, [
          _createVNode(ButtonComponent, { btnWidth: "quinary" }, {
            default: _withCtx(() => [
              _createTextVNode("Cancel")
            ]),
            _: 1
          })
        ]),
        _createVNode(ButtonComponent, {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (save()))
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(SectionTitle, { title: "Intake" })
        ]),
        (loaded.value)
          ? (_openBlock(), _createElementBlock("form", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Last Name",
                  placeholder: "Last name",
                  name: "last_name",
                  id: "last_name",
                  required: "",
                  modelValue: form.value.last_name,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.value.last_name) = $event)),
                  error: errors.value?.last_name
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "First Name",
                  placeholder: "First name",
                  name: "first_name",
                  id: "first_name",
                  required: "",
                  modelValue: form.value.first_name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((form.value.first_name) = $event)),
                  error: errors.value?.first_name
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Middle Name",
                  placeholder: "Middle name",
                  name: "middle_name",
                  id: "middle_name",
                  modelValue: form.value.middle_name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((form.value.middle_name) = $event)),
                  error: errors.value?.middle_name
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("div", _hoisted_13, [
                  _createVNode(RadioGroup, {
                    options: genders.value,
                    name: "gender",
                    required: "",
                    modelValue: form.value.gender,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.value.gender) = $event))
                  }, null, 8, ["options", "modelValue"])
                ]),
                (errors.value?.gender)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass(["text-[10px] mt-1", errors.value?.gender ? 'text-red-600' : 'text-gray-800']),
                      id: "email-error"
                    }, _toDisplayString(errors.value?.gender), 3))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createVNode(DatePicker, {
                  id: "birthdate",
                  name: "birthdate",
                  label: "Birthdate",
                  disabled: disabledBirthdate.value,
                  modelValue: form.value.birthdate,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.value.birthdate) = $event)),
                  error: errors.value?.birthdate
                }, null, 8, ["disabled", "modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createVNode(TextInput, {
                  type: "number",
                  label: "Age",
                  placeholder: "age",
                  name: "approximate_age",
                  id: "approximate_age",
                  disabled: disabledAge.value,
                  modelValue: form.value.approximate_age,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((form.value.approximate_age) = $event)),
                  error: errors.value?.approximate_age
                }, null, 8, ["disabled", "modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(MultiSelect, {
                  searchable: "",
                  options: legalStatuses.value || [],
                  id: "legal_status",
                  name: "legal_status",
                  label: "Legal Status",
                  placeholder: "Select..",
                  modelValue: form.value.legal_status,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((form.value.legal_status) = $event)),
                  error: errors.value?.legal_status
                }, null, 8, ["options", "modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createVNode(MultiSelect, {
                  searchable: "",
                  options: relationships.value || [],
                  id: "relationship",
                  name: "relationship",
                  label: "Relationship",
                  placeholder: "Select..",
                  modelValue: form.value.relationship_id,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.value.relationship_id) = $event)),
                  error: errors.value?.relationship_id
                }, null, 8, ["options", "modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Other relationship",
                  placeholder: "Other relationship",
                  name: "other_relationship",
                  id: "other_relationship",
                  modelValue: form.value.other_relationship,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.value.other_relationship) = $event)),
                  error: errors.value?.other_relationship
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Contact Number",
                  placeholder: "Contact Number",
                  name: "contacts",
                  id: "contacts",
                  add_on_left: true,
                  add_on_text: "+63",
                  maxlength: 10,
                  onKeypress: _unref(numberonly),
                  modelValue: form.value.contacts,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.value.contacts) = $event)),
                  error: errors.value?.contacts
                }, null, 8, ["onKeypress", "modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, [
                  _createVNode(RadioGroup, {
                    options: yesNoOption,
                    name: "livesWithChild",
                    required: "",
                    modelValue: form.value.is_living_with_child,
                    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((form.value.is_living_with_child) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                (errors.value?.is_living_with_child)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass(["text-[10px] mt-1", errors.value?.is_living_with_child ? 'text-red-600' : 'text-gray-800']),
                      id: "email-error"
                    }, _toDisplayString(errors.value?.is_living_with_child), 3))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(MultiSelect, {
                  searchable: "",
                  options: civilStatuses.value,
                  id: "civil_status",
                  name: "civil_status",
                  label: "Civil Status",
                  placeholder: "Select..",
                  modelValue: form.value.civil_status_id,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.value.civil_status_id) = $event)),
                  error: errors.value?.civil_status_id
                }, null, 8, ["options", "modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _hoisted_25,
                _createElementVNode("div", _hoisted_26, [
                  _createVNode(RadioGroup, {
                    options: yesNoOption,
                    name: "employed",
                    required: "",
                    modelValue: form.value.is_employed,
                    "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((form.value.is_employed) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                (errors.value?.is_employed)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass(["text-[10px] mt-1", errors.value?.is_employed ? 'text-red-600' : 'text-gray-800']),
                      id: "email-error"
                    }, _toDisplayString(errors.value?.is_employed), 3))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("div", _hoisted_29, [
                  _createVNode(RadioGroup, {
                    options: yesNoOption,
                    name: "ofw",
                    required: "",
                    modelValue: form.value.is_ofw,
                    "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((form.value.is_ofw) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                (errors.value?.is_ofw)
                  ? (_openBlock(), _createElementBlock("p", {
                      key: 0,
                      class: _normalizeClass(["text-[10px] mt-1", errors.value?.is_ofw ? 'text-red-600' : 'text-gray-800']),
                      id: "email-error"
                    }, _toDisplayString(errors.value?.is_ofw), 3))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Occupation",
                  placeholder: "Occupation",
                  name: "occupation",
                  id: "occupation",
                  modelValue: form.value.occupation,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((form.value.occupation) = $event)),
                  error: errors.value?.occupation
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Weekly Income",
                  placeholder: "Weekly Income",
                  name: "weekly_income",
                  id: "weekly_income",
                  modelValue: form.value.weekly_income,
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((form.value.weekly_income) = $event)),
                  error: errors.value?.weekly_income
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(MultiSelect, {
                  searchable: "",
                  options: housingClassifications.value,
                  id: "housing_classification",
                  name: "housing_classification",
                  label: "Housing Classification",
                  placeholder: "Select..",
                  modelValue: form.value.housing_classification_id,
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((form.value.housing_classification_id) = $event)),
                  error: errors.value?.housing_classification_id
                }, null, 8, ["options", "modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(MultiSelect, {
                  searchable: "",
                  options: socioEconomics.value,
                  id: "socio_economic_status",
                  name: "socio_economic_status",
                  label: "Socio Economic Status",
                  placeholder: "Select..",
                  modelValue: form.value.socio_economic_status_id,
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((form.value.socio_economic_status_id) = $event)),
                  error: errors.value?.socio_economic_status_id
                }, null, 8, ["options", "modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Number of Children in the Family",
                  placeholder: "Number of Children in the Family",
                  name: "number_children",
                  id: "number_children",
                  modelValue: form.value.family_children_count,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((form.value.family_children_count) = $event)),
                  error: errors.value?.family_children_count
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Number of Household Members",
                  placeholder: "Number of Household Members",
                  name: "number_household_members",
                  id: "number_household_members",
                  modelValue: form.value.house_member_count,
                  "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((form.value.house_member_count) = $event)),
                  error: errors.value?.house_member_count
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_36, [
                _createVNode(TextInput, {
                  type: "text",
                  label: "Number of Families in Household",
                  placeholder: "Number of Families in Household",
                  name: "number_families",
                  id: "number_families",
                  modelValue: form.value.house_family_count,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((form.value.house_family_count) = $event)),
                  error: errors.value?.house_family_count
                }, null, 8, ["modelValue", "error"])
              ]),
              _createElementVNode("div", _hoisted_37, [
                _createVNode(TextInput, {
                  textarea: "",
                  label: "Brief Family Background",
                  placeholder: "Brief Family Background",
                  name: "brief_family_background",
                  id: "brief_family_background",
                  textAreaRows: 1,
                  modelValue: form.value.family_background,
                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((form.value.family_background) = $event)),
                  error: errors.value?.family_background
                }, null, 8, ["modelValue", "error"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(SuccessModal, {
        show: showSuccess.value,
        onConfirm: _cache[24] || (_cache[24] = ($event: any) => (redirectSuccess())),
        "action-text": "Close",
        title: "Record updated!",
        content: successMessage.value
      }, null, 8, ["show", "content"])
    ]),
    _: 1
  }, 8, ["backLink"]))
}
}

})